<template>
    <div class="w100">
        <b-row>
            <b-col cols="3" class="text-left">
                <!-- Level -->
                <p>{{ $t("messages.level") }} ({{hidroValues.hidro.measure}}):</p>
            </b-col>
            <b-col cols="9" class="text-left">
                <number-input v-model.number="HIDRO" :min="0" :max="MAXVAL" inline center controls size="small"></number-input>
                <!-- <p class="xs">{{ $t("messages.currentValue") }}: {{hidroValues.hidro.current / 10 }}</p> -->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="3" class="text-left">
                <!-- Cover -->
                <p>{{ $t("messages.cover") }}:</p>
            </b-col>
          <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <b-button class="optInt" style="margin:0px;"  @click="hidroValues.hidro.cover_enabled = 0" :pressed="hidroValues.hidro.cover_enabled  === 0">OFF </b-button>
                <b-button class="optInt" style="margin:0px;"  @click="hidroValues.hidro.cover_enabled = 1" :pressed="hidroValues.hidro.cover_enabled  === 1">ON</b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row v-if="hidroValues.hidro.cover_enabled === 1">
            <b-col cols="3" class="text-left">
                <!-- Reduction -->
                <p >{{ $t("messages.reduction") }} (%):</p>
            </b-col>
            <b-col cols="9" class="text-left">
                <number-input v-model="hidroValues.hidro.reduction"  :min="1" :max="100" inline center controls size="small"></number-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="3" class="text-left">
                <!-- Choque -->
                <p>{{ $t("messages.shock") }}:</p>
            </b-col>
          <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <b-button class="optInt" style="margin:0px;" @click="hidroValues.hidro.cloration_enabled = 0" :pressed="hidroValues.hidro.cloration_enabled === 0">OFF</b-button>
                <b-button class="optInt" style="margin:0px;" @click="hidroValues.hidro.cloration_enabled = 1" :pressed="hidroValues.hidro.cloration_enabled === 1">ON</b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row v-if="hidroValues.hidro.temperature_enabled">
            <b-col cols="3" class="text-left">
                <!-- Temperature -->
                <p >{{ $t("messages.temperature") }}:</p>
            </b-col>
            <b-col cols="9" class="text-left">
                <number-input v-model="hidroValues.hidro.temperature_value"  :min="1" :max="100" inline center controls size="small"></number-input>
            </b-col>
        </b-row>
        <b-row v-if="hidroControl">
            <b-col cols="3" class="text-left">
                <!-- Control by -->
                <p>{{ $t("messages.controlBy") }}</p>
            </b-col>
          <b-col cols="9" class="text-left">
            <b-button-group id="mode" class="menuOpt">
                <b-button class="optInt" style="margin:0px;"  @click="hidroValues.hidro.control = 0" :pressed="hidroValues.hidro.control  === 0">RX </b-button>
                <b-button class="optInt" style="margin:0px;"  @click="hidroValues.hidro.control = 1" :pressed="hidroValues.hidro.control  === 1">CL</b-button>
            </b-button-group>
          </b-col>
        </b-row>
    <actions :has-changes="hasChanges" v-on:onSave="onPreSave" v-on:onCancel="onCancel"></actions>

    <b-modal ref="my-modal" hide-footer centered title="Info">
      <div class="d-block text-center">
        <h5>  {{ $t("messages.desinfection",{ value:controlledStr })}}</h5>
      </div>
      <button class="float-right btn btnPerso " @click="onSave(1)">
          {{ $t("messages.yes") }}
        </button>
        <button class="float-right btn btnPerso " @click="onSave(0)">
          {{ $t("messages.no") }}
        </button>
    </b-modal>
    </div>
</template>

<script>
import VueNumberInput from '@chenfengyuan/vue-number-input';
import Actions from "./utils/Actions";

export default {
    name: 'Hidro',
    components:{
        Actions
    },
    props: {
        poolId:Object
    },
    data() {
        return {
            hasChanges: false,
            hidroValues:{
                'hidro':{
                    'level':0,
                    'measure': 0
                }
            },
            controlledStr:null
        }
    },
    methods:{
        onPreSave() {
            if((this.hidroValues.main.hasRX || this.hidroValues.main.hasCL) && this.hidroValues.hidro.cloration_enabled){
                this.controlledStr = this.getControlledBy();
                this.$refs['my-modal'].show()
            }else{
                this.onSave(1);
            }
        },
        onSave(control){
            this.hidroValues.hidro['disable'] = control;  
            this.$refs['my-modal'].hide()
            this.$emit('onSave',this.original, this.hidroValues, 'hidro');
            this.original = JSON.parse(JSON.stringify(this.hidroValues));
            this.hasChanges = false
        },
        onCancel() {
            this.hidroValues = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        },
        getTime: function(value) {
            return this.$moment.unix(value).utc().hours()+'h '+this.$moment.unix(value).utc().minutes()+'min '+this.$moment.unix(value).utc().seconds()+'s'
        },
        getControlledBy: function(){
            let _hidroControl = (this.hidroValues.hidro.control == 0) ? 'RX' : 'CL';
            if( this.hidroValues.main.hasRX && this.hidroValues.main.hasCL) return _hidroControl
            if( this.hidroValues.main.hasRX && !this.hidroValues.main.hasCL) return 'RX'
            if( !this.hidroValues.main.hasRX && this.hidroValues.main.hasCL) return 'CL'
            return false;
        }
    
    },
    watch: {
        'hidroValues': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.hidroValues = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
    },

    computed: {
        hidroControl: {
            get() {
                let original = JSON.parse(JSON.stringify(this.poolId));
                if( (original.main.hasRX && original.main.hasCL) && original.hidro.hasHidroControl ) return true
                return false;
            },
            set(values){
                //this.original = values
            }
        },
        HIDRO:{
            get(){
                return Number(parseFloat(this.hidroValues.hidro.level / 10).toPrecision(2));
            },
            set(newValue) { 
                this.hidroValues.hidro.level = Number(parseFloat(newValue * 10).toPrecision(2));
                return newValue;  
            }
        },
        MAXVAL:{
            get(){
                return (this.hidroValues.hidro.measure === '%')? 100  : parseInt(this.hidroValues.hidro.maxAllowedValue / 10)
            }
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/Hidro.vue